import { TestTubeDiagonalIcon } from 'lucide-react';
import { Button } from '@@/ui/primitives';
import { useEffect, useState } from 'react';
import { PathTester } from './path-tester';

export function Header() {
  const [testerOpen, setTesterOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (event.target && !(event.target as HTMLElement).closest('#path-tester')) {
        setTesterOpen(false);
      }
    };

    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setTesterOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <div className='relative min-h-10 h-10' style={{ backgroundColor: 'rgb(17, 24, 39)' }}>
      <div className='mx-auto py-2 h-full px-4 lg:px-6'>
        <div className='flex items-center justify-between h-full'>
          <div className='flex items-center gap-4'>
            <div className='text-sm font-semibold text-white'>Dynamic Flow Configurator</div>
          </div>
          <Button
            variant='ghost'
            size='sm'
            className='text-sm! font-medium! rounded-full text-white'
            onClick={() => setTesterOpen(!testerOpen)}
          >
            <TestTubeDiagonalIcon />
          </Button>
        </div>

        {testerOpen && (
          <div id='path-tester' className='absolute top-8 right-6 z-10 w-2xl shadow-2xl rounded-lg'>
            <PathTester />
          </div>
        )}
      </div>
    </div>
  );
}
